import { SectionSpacer } from '~/ui-rocco/pages/home-page/components/SectionSpacer';
import { EditorialClosing } from '~/ui-rocco/pages/detail-shared';
import { ProfessionalAboutIntroSection } from './sections/ProfessionalAboutIntroSection';
import { ProfessionalAboutContentSection } from './sections/ProfessionalAboutContentSection';
import { ProfessionalContactSection } from './sections/ProfessionalContactSection';

/**
 * BC-4572 — revamped professional About tab (/info).
 *
 * Light editorial shell: hero + sub-nav, the "About us" intro (project value +
 * CTAs), the serif editorial lead + a numbered accordion (About / Awards /
 * custom tabs / Meet the Team), then the shared "Talk to us" + closing.
 * Rendered behind the revamp flag; the index route serves overview data so the
 * reused sections resolve.
 */
export const ProfessionalAboutPageRevamp = () => {
    return (
        <main
            id="main-content"
            data-testid="professional-about-page-revamp"
            className="bg-white"
        >
            <ProfessionalAboutIntroSection />
            <SectionSpacer
                height={65}
                mobileHeight={12}
                className="bg-white"
                unit="rem"
            />
            <ProfessionalAboutContentSection />
            <ProfessionalContactSection />
            <EditorialClosing hideHero />
        </main>
    );
};
